<script setup lang="ts">
const { model } = defineProps(['model'])

const config = useRuntimeConfig()

const height = computed(() => {
  return model?.formHeight?.value || 1050
})

const iframeSrc = computed(() => {
  const baseUrl = config.public.dynamicFormsUrl?.replace(/\/$/, '')
  const encodedPath = model?.formPath?.value
    .split('/')
    .map((segment: string) => encodeURIComponent(segment))
    .join('/')

  if (!baseUrl || !encodedPath) {
    return ''
  }

  return `${baseUrl}/${encodedPath}?embed=true&formClass=oneEightyMedical`
})
</script>

<template>
  <iframe
    v-if="iframeSrc"
    :src="iframeSrc"
    :title="model?.title?.value"
    width="100%"
    :height="height"
    style="border:0"
    loading="lazy"
    allowfullscreen
  />
</template>
